import LaunchDarkly from '@module/launchdarkly';

import { EXPERIMENT_LOCKDOWN_RECIPIENT } from '@constant/experiments';

export function isDefaultRecipientInUploadLocked(
  country,
  channelDefaultRecipient,
  userLoggedIn,
  channelName,
  accountSubDomainName
) {
  const isDefaultRecipientSet =
    country === 'NL' &&
    LaunchDarkly.getVariant(EXPERIMENT_LOCKDOWN_RECIPIENT) &&
    channelDefaultRecipient !== false;

  if (!isDefaultRecipientSet) return false;

  if (!userLoggedIn) return true;

  if (!accountSubDomainName) {
    return channelName !== false;
  }

  return accountSubDomainName !== channelName;
}
